import React from "react";
import { assetUrl } from "../../../utils/assetUrl";
import "../itemDetail/s.css";

const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=%2B5492604417126&text=";

const ItemDetailBotella = ({ item }) => {
  const whatsappLink =
    WHATSAPP_URL +
    encodeURIComponent(`Hola, me gustaría consultar por ${item.Titulo}.`);

  return (
    <div className="detail">
      <div className="detailImg">
        <img src={assetUrl(item.imagen)} alt={item.Titulo} />
      </div>
      <div className="detailText">
        <h1>{item.Titulo}</h1>
        <p>{item.Tipo || "VINO TINTO"}</p>
        <br />
        <p className="descripcion">{item.Descripcion}</p>
        <p>
          <b>Indicación de Procedencia:</b> {item.IndicacionDeProcedencia}
        </p>
        <p>
          <b>Georreferencia del viñedo:</b> {item.Georreferencia}
        </p>
        {item.AnioPlantacion && (
          <p>
            <b>Año de plantación del viñedo:</b> {item.AnioPlantacion}
          </p>
        )}
        {item.Cosecha && (
          <p>
            <b>Cosecha:</b> {item.Cosecha}
          </p>
        )}
        {item.Nota && <p>{item.Nota}</p>}
        <p>{item.PartidaLimitada}</p>
        <div className="botones">
          <div className="boton">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <button type="button">Consultar por WhatsApp</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDetailBotella;
